import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Sidebar from "../components/layout/Sidebar";
import Header from "../components/layout/Header";
import ResourceList from "../components/resources/ResourceList";
import EmptyState from "../components/resources/EmptyState";
import { useTranslation } from "react-i18next";
import { BASE_URL } from "../config";

const EducationalResourcePage = () => {
  const { t, i18n } = useTranslation();
  const [resources, setResources] = useState([]);
  const [loading, setLoading] = useState(true);

  const isRtl = i18n.language.includes("fa");

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      if (!user?.token) return;

      setLoading(true);

      const res = await fetch(`${BASE_URL}/resource/me/list`, {
        headers: { "x-access-token": user.token },
      });

      const json = await res.json();
      setResources(json?.data || []);
    } catch {
      setResources([]);
    } finally {
      setLoading(false);
    }
  };

  const mainContentClass = `flex-1 flex flex-col px-2 pb-5 lg:px-0 lg:pb-0 ${
    isRtl ? "md:mr-64" : "md:ml-64"
  }`;
  const mainSectionClass = `flex-1 overflow-y-auto p-4 md:p-6 bg-gray-100 rounded-[16px] ${
    isRtl ? "lg:me-3 lg:mb-3" : "lg:ms-3 lg:mb-3"
  }`;

  return (
    <div className="flex h-screen">
      <Helmet>
        <title>{t("educational_resources.page_title")}</title>
      </Helmet>

      <Sidebar />
      <div className={mainContentClass}>
        <Header />
        <main className={mainSectionClass}>
          <h1 className="text-2xl font-bold text-gray-800 mb-6">
            {t("educational_resources.page_header")}
          </h1>

          {loading ? (
            <div className="bg-white rounded-xl p-6 shadow text-sm text-gray-500">
              {t("common.loading", "در حال بارگذاری...")}
            </div>
          ) : resources.length > 0 ? (
            <ResourceList resources={resources} />
          ) : (
            <EmptyState message={t("educational_resources.empty_state_message")} />
          )}
        </main>
      </div>
    </div>
  );
};

export default EducationalResourcePage;
